import React from 'react';
import { Bubble } from '@ant-design/x';
import { RobotOutlined, SmileOutlined } from '@ant-design/icons';
import { theme } from 'antd';

export interface AIBuilderChatBubbleProps {
  role: 'bot' | 'kid';
  content?: React.ReactNode;
  header?: React.ReactNode;
  loading?: boolean;
}

export const AI_BUILDER_BOT_NAME = 'Tilmi';

const AIBuilderChatBubble: React.FC<AIBuilderChatBubbleProps> = ({ role, content, header, loading }) => {
  const { token } = theme.useToken();
  const isBot = role === 'bot';
  const accentBorder = isBot ? token.colorPrimaryBorder : token.colorSuccessBorder;
  const avatarBg = isBot ? token.colorPrimaryActive : token.colorSuccessActive;
  return (
    <Bubble
      placement={isBot ? 'start' : 'end'}
      variant="filled"
      shape="corner"
      avatar={{
        icon: isBot ? <RobotOutlined /> : <SmileOutlined />,
        shape: 'circle',
        size: 40,
        style: { backgroundColor: avatarBg },
      }}
      styles={{
        content: {
          background: isBot ? token.colorBgContainer : token.colorSuccessBg,
          border: `2px solid ${accentBorder}`,
          boxShadow: `0 4px 0 ${accentBorder}`,
          color: token.colorText,
          borderRadius: token.borderRadiusLG,
        },
      }}
      header={header}
      loading={loading}
      content={content}
    />
  );
};

export default AIBuilderChatBubble;
